import Alert from '@mui/material/Alert'
import Collapse from '@mui/material/Collapse'
import { type ReactElement, useState } from 'react'
import { Trans } from 'react-i18next'

const CarrierProfileBanner = (): ReactElement | null => {
  const [carrierBannerOpen, setCarrierBannerOpen] = useState(true)

  const handleBannerClose = (): void => {
    setCarrierBannerOpen(false)
  }

  return (
    <Collapse in={carrierBannerOpen}>
      <Alert data-test="carrier-profile-banner" severity="info" variant="standard" sx={{ marginBottom: 2 }} onClose={handleBannerClose}>
        <Trans
          i18nKey={'screens.cs.carrier_profile.banner.profile_page'}
          components={{ strong: <strong /> }}>
        </Trans>
      </Alert>
    </Collapse>
  )
}

export default CarrierProfileBanner
